import('./Bootstrap').then(({ renderApp }) => {
  renderApp();
});
